export default function Worker_fn() {
  return new Worker(__webpack_public_path__ + "engineDeviation.worker.d6c4e505dfda101df439-838.worker.js");
}
